import { BankAccount } from '@/api/payment-orders';

export interface EIRAItemProps {
  invoiceId: string;
  payer: BankAccount;
  payee: string;
  amount: number;
  taxRate: number;
  interest: number;
  invoiceDate: Date;
  invoiceDueDate: Date;
}

export default class EIRAItem implements EIRAItemProps {
  amount: number;

  interest: number;

  invoiceDate: Date;

  invoiceDueDate: Date;

  invoiceId: string;

  payee: string;

  payer: BankAccount;

  taxRate: number;

  constructor(EIRAItemDto: EIRAItemProps) {
    this.amount = EIRAItemDto.amount;
    this.interest = EIRAItemDto.interest;
    this.invoiceDate = EIRAItemDto.invoiceDate;
    this.invoiceDueDate = EIRAItemDto.invoiceDueDate;
    this.invoiceId = EIRAItemDto.invoiceId;
    this.payee = EIRAItemDto.payee;
    this.payer = EIRAItemDto.payer;
    this.taxRate = EIRAItemDto.taxRate;
  }

  get baseAmount(): number {
    return (this.amount - this.interest) / (1 + this.taxRate);
  }

  get taxAmount(): number {
    return this.baseAmount * this.taxRate;
  }
}
